
<app-header></app-header>
<div class="body-wrapper" id="main-content" aria-label="Main Content">
    <router-outlet></router-outlet>
<app-footer></app-footer>

</div>